export default "__VITE_ASSET__FjZqRRj0__"